module.exports = __webpack_public_path__ + "static/isometric-greatest-potential-aa180261e0aee0e59e70121aa3e6956c.svg";